const KEY = 'tenantBranding';
const DEFAULT_BRANDING = {
  companyName: 'Ace Relocations',
  logoUrl: '',
  primaryColor: '#3B82F6',
  secondaryColor: '#0F172A',
  accentColor: '#06B6D4',
  neutralColor: '#475569',
  headerHtml: '<strong>Ace Relocations</strong>',
  headerTagline: 'We Make Moving Easy',
  footerHtml: '',
  supportEmail: 'info@acerelocations.co.in',
  supportPhone: 'Mob : 98252 19378, Ph : +91-79-4890 1434',
  addressBlock:
    '310, Arista Business Spaces, Opp. Stellar, Sidhu Bhavan Road, Off S G Highway, Ahmedabad - 380054.',
  footerWebsite: 'www.acerelocations.co.in',
  footerTagline: 'Serving Pan India & Overseas',
  footerServicesPreset: 'custom',
  headOfficeCity: '',
  footerServicesText: [
    'House Hold Relocation - Domestic & International',
    'Office & Data Center Relocation',
    'Short & Long Term Storage',
    'Vehicle Relocation',
    'Antique, Fine Arts & High Value Item Relocation',
    "Trade Show & Mock - Up's",
  ].join('\n'),
};

export function readTenantBranding() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return { ...DEFAULT_BRANDING, ...(parsed || {}) };
  } catch (_) {
    return { ...DEFAULT_BRANDING };
  }
}

export function storeTenantBranding(branding) {
  if (!branding || typeof branding !== 'object') return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...DEFAULT_BRANDING, ...branding }));
  } catch (_) {
    /* ignore */
  }
}

/** Merge API/caller overrides with cached branding for PDF generation. */
export function brandingForPdf(override) {
  const cached = readTenantBranding();
  if (!override || typeof override !== 'object') return cached;
  return { ...cached, ...override };
}
